// import needed stuff
import { i18n } from '@moxiltd/moxijs/src/i18n.js';
import browserUpdate from 'browser-update';
import { Form } from './form.js';
import * as functions from './functions.ts';
import { Tabs } from './components/tabs.js';
import { Accordion } from './components/accordion.js';
import { Modal } from './components/modal.js';
import { Slider } from './components/slider.js';
import { Sidebar } from "./sidebar.js";

import './general.ts';
import './menu.ts';
import './sidebar.ts';
import './onepager.ts';
import './movie_list.ts';
import './share-buttons.js';

// load polyfills if needed
import './legacySupport.js';

new Sidebar();

// make moxi functions available from outside, e.g. templates
window.moxi = {
    i18n,
    Form,
    functions,
    Tabs,
    Accordion,
    Modal,
    Slider,
};

window.ShareButtons = ShareButtons;

// browser update
window.browserUpdate = browserUpdate;

// trigger moxiJsLoaded event
document.dispatchEvent(new Event('moxiJsLoaded'));
